import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { apiFetch } from '../lib/api'

export function Verify() {
  const [file, setFile] = useState<File | null>(null)
  const [uploading, setUploading] = useState(false)
  const [result, setResult] = useState<any>(null)
  const navigate = useNavigate()
  const { refreshUser } = useAuth()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!file) return

    setUploading(true)
    try {
      const formData = new FormData()
      formData.append('document', file)

      const data = await apiFetch('/api/worker/verify-cscs', {
        method: 'POST',
        body: formData,
        headers: {}, // Let browser set Content-Type for FormData
      })

      setResult(data)
      await refreshUser()
    } catch (err) {
      alert('Upload failed. Try again.')
    }
    setUploading(false)
  }

  if (result) {
    return (
      <div className="page verify">
        <div className="verify-result">
          <div className={`result-icon ${result.status}`}>
            {result.status === 'approved' ? '✓' : result.status === 'rejected' ? '✗' : '⏳'}
          </div>
          <h1>
            {result.status === 'approved' ? 'Verified!' :
             result.status === 'rejected' ? 'Not verified' :
             'Under review'}
          </h1>
          <p>
            {result.status === 'approved' ? 'Your CSCS card has been verified. You can now generate codes.' :
             result.status === 'rejected' ? 'Your card could not be verified. Please try again with a clearer photo.' :
             'Your card is being reviewed. This usually takes a few minutes.'}
          </p>
          {result.confidence && (
            <p className="confidence">Confidence: {(result.confidence * 100).toFixed(0)}%</p>
          )}
          <button className="btn-primary" onClick={() => navigate('/')}>
            Continue
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="page verify">
      <div className="verify-card">
        <h1>Verify your CSCS card</h1>
        <p>Upload a photo of your valid CSCS card. This is automated — takes seconds.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="upload-area">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              id="file-input"
              className="file-input"
            />
            <label htmlFor="file-input" className="upload-label">
              {file ? (
                <span className="file-name">{file.name}</span>
              ) : (
                <>
                  <span className="upload-icon">📷</span>
                  <span>Tap to take photo or choose file</span>
                </>
              )}
            </label>
          </div>

          <button type="submit" className="btn-primary" disabled={!file || uploading}>
            {uploading ? 'Verifying...' : 'Verify card'}
          </button>
        </form>
      </div>
    </div>
  )
}
